<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Aftrekbare financieringskosten
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als er sprake is van de eigenwoningregeling, dan zijn bij de aangifte zijn de volgende
                financieringskosten aftrekbaar:
                <li class="list">bemiddelingskosten bij het verkrijgen van je hypotheek, zoals advies- en
                    afsluitkosten
                </li>
                <li class="list">notariskosten voor de hypotheekakte en het kadastraal recht hierover</li>
                <li class="list">betaalde oversluitkosten</li>
                <li class="list">taxatiekosten (alleen om een lening te krijgen)</li>
                <li class="list">kosten van de aanvraag van Nationale Hypotheek Garantie</li>
                <li class="list">bouwrente over de periode nadat de voorlopige koopovereenkomst werd gesloten</li>
                <li class="list">onder bepaalde voorwaarden: kosten van een verbouwingsdepot of een nieuwbouwdepot.</li>

                <div class="space10"></div>
                Meer hierover vind je bij de hieronder vermelde 'Meer fiscale informatie'.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2"
                    aria-expanded="false" aria-controls="collapse2">
                Schuld gedeeltelijk in box 1 en in box 3
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het kan zijn dat een hypothecaire schuld deels aan te merken is als box 1-lening (eigen woning) en deels
                als een box 3-lening (consumptieve lening). Als er voor de schuld sprake is van financieringskosten, dan
                zijn deze kosten alleen aftrekbaar voorzover het het gedeelte betreft dat in box 1 zit.
                <div class="space10"></div>

                Vul bij de vraag over de financieringskosten daarom alleen het aftrekbare deel in. Let dus op dat het
                programma niet zelf berekend wel deel wel of niet aftrekbaar is.

            </div>
        </div>
    </div>

</div>
